import { createSelector } from '@reduxjs/toolkit';

const baseSelector = (state) => state.coursePauseRequestFilter;

export const coursePauseRequestFilterSelector = baseSelector;

export const isModalOpenSelector = createSelector(
  (state) => baseSelector(state).isModalOpen,
  (isModalOpen) => isModalOpen
);

export const appliedFiltersSelector = createSelector(
  (state) => baseSelector(state).learnerEmail.applied,
  (state) => baseSelector(state).currentBatch.applied,
  (state) => baseSelector(state).newBatch.applied,
  (state) => baseSelector(state).fromToBeResumedDate.applied,
  (state) => baseSelector(state).untilToBeResumedDate.applied,
  (state) => baseSelector(state).pauseDuration.applied,
  (state) => baseSelector(state).courseType.applied,
  (
    learnerEmail,
    currentBatch,
    newBatch,
    fromToBeResumedDate,
    untilToBeResumedDate,
    pauseDuration,
    courseType
  ) => ({
    learnerEmail,
    currentBatch,
    newBatch,
    fromToBeResumedDate,
    untilToBeResumedDate,
    pauseDuration,
    courseType,
  })
);

export const currentFiltersSelector = createSelector(
  (state) => baseSelector(state).learnerEmail.current,
  (state) => baseSelector(state).currentBatch.current,
  (state) => baseSelector(state).newBatch.current,
  (state) => baseSelector(state).fromToBeResumedDate.current,
  (state) => baseSelector(state).untilToBeResumedDate.current,
  (state) => baseSelector(state).pauseDuration.current,
  (state) => baseSelector(state).courseType.current,
  (
    learnerEmail,
    currentBatch,
    newBatch,
    fromToBeResumedDate,
    untilToBeResumedDate,
    pauseDuration,
    courseType
  ) => ({
    learnerEmail,
    currentBatch,
    newBatch,
    fromToBeResumedDate,
    untilToBeResumedDate,
    pauseDuration,
    courseType,
  })
);
